import { useQuery } from "@apollo/client";

import {
  GET_COMPANY_CATEGORIES_QUERY,
  GET_COMPANY_CATEGORY_QUERY,
} from "./documents";
import {
  TGetCompanyCategoriesData,
  TGetCompanyCategoriesOptions,
  TGetCompanyCategoriesVariables,
  TGetCompanyCategoryData,
  TGetCompanyCategoryOptions,
  TGetCompanyCategoryVariables,
} from "./types";

export function useGetCompanyCategoriesQuery(
  options?: TGetCompanyCategoriesOptions
) {
  const query = useQuery<
    TGetCompanyCategoriesData,
    TGetCompanyCategoriesVariables
  >(GET_COMPANY_CATEGORIES_QUERY, options);

  return query;
}

export function useGetCompanyCategoryQuery(
  options?: TGetCompanyCategoryOptions
) {
  const query = useQuery<TGetCompanyCategoryData, TGetCompanyCategoryVariables>(
    GET_COMPANY_CATEGORY_QUERY,
    options
  );

  return query;
}
